import { render, staticRenderFns } from "./iconPicker.vue?vue&type=template&id=10134f64&scoped=true&"
import script from "./iconPicker.vue?vue&type=script&lang=js&"
export * from "./iconPicker.vue?vue&type=script&lang=js&"
import style0 from "./iconPicker.vue?vue&type=style&index=0&id=10134f64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10134f64",
  null
  
)

export default component.exports